import * as React from 'react';
import { Search, X } from 'lucide-react';
import { cn } from '../../lib/utils';

// Recherche toujours visible : sur une liste de travail, chercher est le
// geste le plus fréquent, il ne doit pas se cacher derrière une loupe.
interface SearchFieldProps {
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  className?: string;
  ariaLabel?: string;
}

export const SearchField = React.forwardRef<HTMLInputElement, SearchFieldProps>(
  ({ value, onChange, placeholder, className, ariaLabel }, ref) => (
    <label
      className={cn(
        'flex h-9 w-full items-center gap-2 rounded-md border border-white/[0.14] px-3 text-muted-foreground focus-within:border-white/30 sm:w-72',
        className,
      )}
    >
      <Search size={14} className="shrink-0" />
      <input
        ref={ref}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Escape') onChange(''); }}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        className="h-full min-w-0 flex-1 bg-transparent text-sm text-foreground outline-none placeholder:text-muted-foreground [&::-webkit-search-cancel-button]:hidden"
      />
      {value && (
        <button type="button" onClick={() => onChange('')} aria-label="Effacer" className="hover:text-foreground">
          <X size={14} />
        </button>
      )}
    </label>
  ),
);
SearchField.displayName = 'SearchField';
